<template>
  <div class="home">
    <SaleSurveyList v-show="listView" @newSales="onClickNewFromList" @editSales="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <SaleSurveyForm v-show="formView" :order="order" @backClicked="onBackChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import SaleSurveyList from '@/components/sales/SaleSurveyList.vue'
import SaleSurveyForm from '@/components/sales/SaleSurveyForm.vue'
import { saleOrderUrl, getHeader } from '../config'

export default {
  name: 'SaleOrder',
  components: {
    SaleSurveyList,
    SaleSurveyForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      order: {
        id: null,
        order_no: null,
        order_date: null,
        order_due_date: null,
        type_id: null,
        price_id: null,
        customer_no: null,
        customer: [{
          id: null,
          name: null,
          phone: null,
          address: null
        }],
        branch_no: null,
        branch: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        status: null,
        sale_no: null,
        salesman_id: null,
        salesman: null,
        surveyor_id: null,
        surveyor: null,
        details: [{
          id: null,
          order_no: null,
          order_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product: null,
          description: null,
          qty: 0,
          serial_number: null,
          uom_id: null,
          uomList: [{
            id: null,
            name: null
          }],
          price: '0',
          cost: '0',
          cost_id: null,
          tax_id: null,
          tax: '0',
          total: '0',
          queue: null,
          state: null
        }],
        attachments: [{
          id: null,
          order_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.order = value
      var obj = {
        priceID: this.order.price_id,
        branch: this.order.branch_no,
        warehouse: null
      }
      this.$store.dispatch('getProductByPriceList', obj)
    },
    getEditSales: function (value) {
      console.log(saleOrderUrl + '/' + value)
      axios.get(saleOrderUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.order = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      const user = JSON.parse(window.localStorage.getItem('authUser'))
      const date = new Date().toISOString()
      this.listView = false
      this.formView = true
      this.order = {
        id: null,
        order_no: null,
        order_date: date,
        order_due_date: null,
        type_id: null,
        price_id: null,
        customer_no: null,
        customer: [{
          id: null,
          name: null,
          phone: null,
          address: null
        }],
        branch_no: user.user.branch_no,
        branch: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        status: null,
        sale_no: null,
        salesman_id: null,
        salesman: null,
        surveyor_id: user.user.id,
        surveyor: null,
        margin: '0',
        details: [{
          order_no: null,
          order_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product: null,
          description: null,
          qty: '0',
          serial_number: null,
          uom_id: null,
          uomList: [{
            id: null,
            name: null
          }],
          price: '0',
          cost: '0',
          cost_id: null,
          discount: '0',
          margin: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          queue: null,
          state: null
        }],
        attachments: [{
          id: null,
          order_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.order = {
        id: null,
        order_no: null,
        order_date: null,
        order_due_date: null,
        type_id: null,
        price_id: null,
        customer_no: null,
        customer: [{
          id: null,
          name: null,
          phone: null,
          address: null
        }],
        branch_no: null,
        branch: null,
        subtotal: '0',
        discount: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        status: null,
        sale_no: null,
        salesman_id: null,
        salesman: null,
        margin: '0',
        details: [{
          id: null,
          order_no: null,
          order_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product: null,
          description: null,
          qty: '0',
          serial_number: null,
          uom_id: null,
          uomList: null,
          price: '0',
          cost: '0',
          cost_id: null,
          discount: '0',
          margin: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          queue: null,
          state: null
        }],
        attachments: [{
          id: null,
          order_no: null,
          filename: null,
          url: null,
          extension: null,
          real_path: null,
          size: null,
          mime_type: null,
          upload_date: null,
          queue: null
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
      this.$refs.refreshList.refreshSales()
    }
  },
  mounted () {
    this.$store.dispatch('getPriceListGroup')
    this.$store.dispatch('getSalesTypeList')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getUserAll')
    // get query param from url
    // var form = this.$route.query.form
    var salesParam = this.$route.query.sales
    if (typeof salesParam !== 'undefined') {
      this.getEditSales(salesParam)
    }
  }
}
</script>
